import { ApiError } from '@/lib/api';

import type { StudyPiiFinding } from './studyApi';

/** Learner copy and response parsing for the "Check the text" step (SIR-QA-07, SIR-TRU-02). */

export const PII_LABELS: Record<string, string> = {
  email: 'Email address',
  phone: 'Phone number',
  tfn: 'Tax file number',
  medicare: 'Medicare number',
  street_address: 'Street address',
  date_of_birth: 'Date of birth',
  student_id: 'Student ID',
};

export interface PiiReview {
  text: string;
  findings: StudyPiiFinding[];
  redactedText: string;
}

/** Reads a 409 STUDY_SOURCE_PII_REVIEW_REQUIRED body; null for every other error. */
export function piiReviewOf(error: unknown, text: string): PiiReview | null {
  if (!(error instanceof ApiError) || error.code !== 'STUDY_SOURCE_PII_REVIEW_REQUIRED')
    return null;
  const details =
    error.details && typeof error.details === 'object'
      ? (error.details as { findings?: unknown; redacted_text?: unknown })
      : {};
  const findings = Array.isArray(details.findings)
    ? details.findings.filter(
        (finding): finding is StudyPiiFinding =>
          typeof finding?.type === 'string' && typeof finding?.count === 'number',
      )
    : [];
  if (typeof details.redacted_text !== 'string' || findings.length === 0) return null;
  return { text, findings, redactedText: details.redacted_text };
}

export function sourceTextErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.code === 'STUDY_SOURCE_PII_CHECK_UNAVAILABLE') {
    return 'We could not check this text for personal details. Nothing was saved. Please try again.';
  }
  return error instanceof Error ? error.message : 'This text could not be saved. Please try again.';
}
